import { render, staticRenderFns } from "./ItemMeasureUnitEditView.vue?vue&type=template&id=03c48bc5"
import script from "./ItemMeasureUnitEditView.vue?vue&type=script&lang=js"
export * from "./ItemMeasureUnitEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports